/*
 * @Description: 微扬官网中文语言包
 * @Author: pliybird
 * @Date: 2023-05-26 15:44:31
 * @LastEditTime: 2025-11-10 14:51:43
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
const home = require("./home.json");
const solution = require("./solution.json");
const solution_crm = require("./solution_crm.json");
const product = require("./product.json");
const service = require("./service.json");
const cases = require("./cases.json");
const news = require("./news.json");
const overseas = require("./overseas.json");
const about_us = require("./about_us.json");
const single_home = require("./single_home.json");
const pp_services = require("./pp_services.json");

export default {
  language: "English",
  feedback: {
    scrollTop: {
      tab01: "微信扫码，在线咨询",
      tab02: "联系我们",
      tab03_1: "业务咨询",
      tab03_2: "提交信息后我们将第一时间联系您",
    },
    form: {
      title: "Business Consultation",
      form_fullname: "Full Name (Required)",
      form_telephone: "Contact Phone (Required)",
      form_emailAddress: "Email Address",
      form_tip1: "Invalid email format",
      form_captcha: "Graphic Verification Code (Required)",
      form_tip2: "Please enter the correct verification code",
      form_companyName: "Company Name (Required)",
      form_companyLocation: "Company Location",
      form_customerIndustry: "Industry",
      form_customerBudget: "Budget Requirement",
      form_consultDetails: "Business Consultation (Required)",
      form_choose: "Please select",
      form_btn: "Submit",
      form_success: "Information submitted successfully",
    },
  },
  footer: {
    contact: "Pre-Sales Consultation",
    fllow: "Follow us",
    wechat_account: "HAND Vyung",
    wechat_channel: "HAND Vyung Official WeChat Channel",
    about_vyung: "About HAND Vyung",
    company_info: "Company Information",
    offices: "Offices",
    news: "News",
    links: "Links",
    hand: "Hand",
    hellos: "HELIOS",
    dingyi: "Dingyi",
    more: "More",
    cases: "Cases",
    copyright: "Shanghai Hand Vyung Information Technology Co.,LTD",
    hand_us: "HAND US",
    hand_jp: "HAND Japan",
    hand_eu: "HAND Europe",
    hand_sg: "HAND Singapore",
  },
  home: home,
  solution: solution,
  solution_crm: solution_crm,
  product: product,
  service: service,
  cases: cases,
  news: news,
  overseas: overseas,
  about_us: about_us,
  single_home,
  pp_services,
};
